import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from "../views/LoginPage.vue";
import ErrorPage from "../views/ErrorPage.vue";



const routes = [
  {
    path: "/login",
    name: "",
    component: LoginPage
  },
  {
    path: "/error",
    name: "ErrorPage",
    component: ErrorPage
  },
  {
    path: "/hikAuthCallback",
    name: "HikAuthCallback",
    component: () => import("@/views/HikAuthCallback.vue"),
    meta: {
      title: "海康互联授权"
    }
  },
  {
    path: "/mobile/monitor",
    name: "MobileMonitorPlay",
    component: () => import("@/views/MobileMonitorPlay.vue"),
    meta: {
      title: "监控播放"
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
